import styled, { css } from 'styled-components';

import { Text, Button, Icon } from '@catalyze/ui';
import type { Status } from 'api/types/lead';
import { leadStatusColor } from 'utils/leadGroupColor';

const infoIcon = css`
    & > svg {
        display: inline-block;
        width: 1.5rem;
        height: 1.5rem;
        margin: 0 0.25rem 0 0;
        fill: ${({ theme }) => theme.colors.fontTertiary};
    }
`;

export const Container = styled.section<{ status: Status }>`
    background: ${({ theme }) => theme.colors.bgTernary};
    box-shadow: ${({ theme }) => theme.boxShadow.primary};
    border-radius: 0.5rem;
    grid-area: info;
    padding: 0.625rem 0.75rem;
    display: grid;
    grid-template-rows: auto auto auto;
    grid-template-columns: auto auto 1fr;
    grid-template-areas:
        'info . buttons-container'
        'basic-info . buttons-container'
        'add-info . buttons-container'
        'owners . buttons-container' 'networth . buttons-container' 'lead-state . buttons-container';
    column-gap: 0.75rem;
    row-gap: 0.75rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-left: 0.75rem solid ${leadStatusColor};
`;

export const Address = styled(Text)`
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSizes[6]};
`;

export const BasicInfo = styled.div`
    grid-area: basic-info;
    display: flex;
    column-gap: 1.5rem;
`;

export const AdditionalInfo = styled.div`
    grid-area: add-info;
    display: flex;
    column-gap: 1.5rem;
`;

export const BasicInfoItem = styled(Text)`
    display: inline-block;
    white-space: nowrap;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    ${infoIcon};
`;

export const NetWorth = styled.span`
    color: ${({ theme }) => theme.colors.fontTertiary};
    grid-area: networth;
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const NetWorthValue = styled.span`
    padding-right: 0.5rem;
    color: ${({ theme }) => theme.colors.logoPrimary};
`;

export const LeadState = styled.span`
    grid-area: lead-state;
    font-size: ${({ theme }) => theme.fontSizes[2]};
    font-weight: normal;
    letter-spacing: -0.15px;
    color: ${({ theme }) => theme.colors.fontTertiary};
`;

export const ButtonsContainer = styled.div`
    grid-area: buttons-container;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    column-gap: 1rem;
    align-items: flex-start;
    margin-top: 0.625rem;
`;

export const KebabIconButton = styled(Button)`
    padding: 0.125rem;
    margin-top: 0.25rem;
    border: none;
    box-shadow: none;

    & svg {
        height: 1.75rem;
    }
`;

export const MenuItemIcon = styled(Icon)`
    width: 1.5rem;
    margin: 0 1rem 0 0;
`;

export const OwnerTitle = styled(Text)`
    grid-area: owners;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    ${infoIcon};
`;
